module.exports = __webpack_public_path__ + "media/images/mailer-new-survey-36b8bb1cb3ab0274721447a4ae1e45fd.png";